import React, { FC } from "react";
import BancontactSVG from "./bancontact.svg";

type Props = JSX.IntrinsicAttributes;

export const BancontactIcon: FC<Props> = (props) => {
  return <BancontactSVG {...props} />;
};
